/**
 * סוג התוצאה אחרי הרשמת מתנדב למשימה – מפשט את ארבעת המצבים לזרימה אחת.
 */
export const VolunteerRegistrationOutcome = {
  /** הרשמה רגילה – רק נרשם, אישור בהצלחה */
  REGULAR: "REGULAR",
  /** התעניינות – מצטרף כמתעניין, ממתין לאישור */
  INTERESTED: "INTERESTED",
  /** הרשמה ופתיחת צ'אט עם מבקש הסיוע לקביעת פרטים */
  CHAT: "CHAT",
  /** הרשמה וקבלת פרטי מבקש הסיוע ב-SMS ליצירת קשר (משימות רגישות) */
  SMS_DETAILS: "SMS_DETAILS",
} as const;

export type VolunteerRegistrationOutcomeType =
  (typeof VolunteerRegistrationOutcome)[keyof typeof VolunteerRegistrationOutcome];

export interface OpportunityForOutcome {
  /** הגדרת ההתנדבות – קובעת את תהליך ההרשמה (לא מבקש סיוע/רגישות/אימות) */
  volunteerRegistrationFlow?: VolunteerRegistrationOutcomeType | null;
}

const VALID_FLOWS: Set<VolunteerRegistrationOutcomeType> = new Set(
  Object.values(VolunteerRegistrationOutcome),
);

/** ברירת מחדל לתהליך הרשמה – באדמין, בקליינט ובשרת. */
export const DEFAULT_VOLUNTEER_REGISTRATION_FLOW =
  VolunteerRegistrationOutcome.SMS_DETAILS;

/** מנרמל ערך שדה תהליך הרשמה (טופס אדמין / שמירה). */
export function resolveVolunteerRegistrationFlow(
  flow?: VolunteerRegistrationOutcomeType | string | null,
): VolunteerRegistrationOutcomeType {
  const value = flow as VolunteerRegistrationOutcomeType;
  return value && VALID_FLOWS.has(value)
    ? value
    : DEFAULT_VOLUNTEER_REGISTRATION_FLOW;
}

export interface OpportunityForAdminRegistrationFlow extends OpportunityForOutcome {
  status?: string | null;
}

/**
 * ברירת מחדל באדמין לאישור בקשת סיוע: פרטי מבקש ב-SMS.
 * שומר בחירה מפורשת (צ'אט / התעניינות / SMS) אחרי שמירת שינויים.
 */
export function resolveVolunteerRegistrationFlowForAdmin(
  opportunity?: OpportunityForAdminRegistrationFlow | null,
): VolunteerRegistrationOutcomeType {
  if (opportunity?.status === "AID_REQUEST") {
    const flow = opportunity.volunteerRegistrationFlow;
    if (flow == null || flow === VolunteerRegistrationOutcome.REGULAR) {
      return VolunteerRegistrationOutcome.SMS_DETAILS;
    }
  }
  return resolveVolunteerRegistrationFlow(opportunity?.volunteerRegistrationFlow);
}

/**
 * מחזיר את סוג תהליך ההרשמה – נקבע רק לפי השדה בהתנדבות.
 */
export function getVolunteerRegistrationOutcome(
  opportunity: OpportunityForOutcome | null | undefined,
): VolunteerRegistrationOutcomeType {
  return resolveVolunteerRegistrationFlow(opportunity?.volunteerRegistrationFlow);
}
